// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"_21BCa","VerticalAnchorsMenuTextSkin":"_3Gir5","verticalAnchorsMenuTextSkin":"_3Gir5","link":"_2SF-c","activeAnchor":"_3rv2-","label":"_3MKwu"};